const fontstyle1 = {
  fontFamily: '"Poppins", sans-serif'
};

const fontstyle2 = {
  fontFamily: '"Titillium Web", sans-serif'
};

const fontstyle3 = {
  fontFamily: '"IBM Plex Mono", monospace'
};

export { fontstyle1, fontstyle2, fontstyle3 };
